// extracted by mini-css-extract-plugin
export default {"mainDivConceirge":"concierge_mainDivConceirge__vTNHD","incresedLeftPdding":"concierge_incresedLeftPdding__r-GfL"};